import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { productAtProductBuilderIsFavouriteSelector } from '../../../../../../redux/favourite-products/favourite-products.selectors';
import { productIdSelector } from '../../../../../../redux/product/product.selectors';
import { isLoggedInSelector } from '../../../../../../redux/user/user.selectors';
import { toolsPanelDispatcher } from '../redesigned-tools-panel/connect/tools-panel.dispatcher';
import { MobileFavoriteButton as MobileFavoriteButtonComponent } from './mobile-favourite-button';
const selectors = createStructuredSelector({
  isFavourite: productAtProductBuilderIsFavouriteSelector,
  isLoggedIn: isLoggedInSelector,
  productId: productIdSelector
});
const actions = dispatch => ({
  onProductFavouriteClick: isLoggedIn => toolsPanelDispatcher(dispatch, {
    isLoggedIn
  }).onProductFavouriteClick
});
const connector = connect(selectors, actions);
export const MobileFavoriteButton = connector(MobileFavoriteButtonComponent);